<div class="obg-m-beta-badge-content" *ngIf="showBetaLink$ | async">
	<span class="badge-content" *ngIf="showBetaLabel">{{ 'beta-site-navigation.beta-tag' | translate }}</span>
	<button class="old-site-link" (click)="goBackToOldSite()">
		{{ 'beta-site-navigation.leave-beta-site' | translate }}
		<span class="beta-badge-back icon ico-chevron-right" role="button"></span>
	</button>
</div>
